
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choosable/picker",
      function () {
        return require("private-next-pages/choosable/picker/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/choosable/picker"])
      });
    }
  